import { useState, useEffect, useRef } from "react";
import emailjs from '@emailjs/browser';
import { Container, Row, Col, } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import e from "cors";


export const Contact = () => {

    const form = useRef();

    const handleSubmit = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_sgcp6qo', 'template_dfu2jam', form.current, '6wKCg-QXxxtGdMI7W')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });

          e.target.reset()
      };

    //   e.target.reset();

    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''

    }

    // store form details
    const [formDetails, setFormDetails] = useState(formInitialDetails);

    // submit button update
    const [buttonText, setButtonText] = useState('Send');

    // has meesage sent successfully (empty object)
    const [status, setStatus] = useState({});

    // // update form details state
    // const onFormUpdate = (category, value) => {
    //     setFormDetails({
    //         ...formDetails,
    //         [category]: value
    //     })
    // }

    // submit function
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setButtonText('Sending...');
    //     let response = await fetch("http://localhost:5000/contact", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "Application/json;charset=utf-8",
    //         },
    //         body: JSON.stringify(formDetails),
    //     });

    //     setButtonText("Send");
    //     let  result = response.json();

    //     setFormDetails(formInitialDetails);

    //     if (result.code === 200) {
    //         setStatus({ success: true, massage: 'Message sent successfully!' });
    //     } else {
    //         setStatus({ success: false, massage: 'Something  went wrong. Please try again!' });
    //     }
    // };

    

    return (
        <section className="contact" id="contact">
            <Container>
                <Row className="align-items-center">
                    <Col size={12} md={6}>
                        <TrackVisibility>
                            {({ isVisible }) => 
                                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Me"/>
                            }
                        </TrackVisibility>
                    </Col>

                    <Col size={12} md={6}>
                    <TrackVisibility>
                        {({ isVisible }) => 
                            <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                <h2>Get In Touch</h2>

                                <form ref={form} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col size={12} sm={6} className="px-1">
                                            <input type="text"  
                                            placeholder="First Name" 
                                            name='user_name' required 
                                            />
                                        </Col>

                                        <Col size={12} sm={6} className="px-1">
                                            <input type="text" 
                                            placeholder="Last Name" 
                                            name='user_name' required
                                            />
                                        </Col>

                                        <Col size={12} sm={6} className="px-1">
                                            <input type="email"  
                                            placeholder="Email Address" 
                                            name='user_email' required
                                            />
                                        </Col>

                                        <Col size={12} sm={6} className="px-1">
                                            <input type="tel"  
                                            placeholder="Phone No." 
                                            name='user_phone' required
                                            />
                                        </Col>
                                        
                                        <Col size={12} className="px-1">
                                            <textarea 
                                            row="6"  
                                            placeholder="Introduce Yourself" 
                                            name='subject' required
                                            />

                                            <button type="submit"><span>{buttonText}</span></button>
                                        </Col>

                                        {
                                            status.message &&
                                            <Col>
                                            <p className={status.success === false ? "danger" : "success"}>{status.message}</p> 
                                            </Col>
                                        }
                                    </Row>
                                </form>
                            </div>
                        }
                    </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>      
    );
}    
    

export default Contact;